var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  _vm.$initSSP()
  if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
    _vm.$setSSP("default", {
      active: _vm.active,
    })
  }
  _vm.$callSSP()
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }